import { Button } from '@material-ui/core';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import imageItems from '../../../data/center.json';
import Banner from '../../atoms/Banner/Banner';
import Typography from '../../atoms/Typography/Typography';
import ImageBox from '../../organisms/ImageBox/ImageBox';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  mainBox: {
    // border: 'solid 3px green',
    width: '80%',
    display: 'flex',
    justifyContent: 'space-between',
    '@media only screen and (max-width: 768px)': {
      flexDirection: 'column',
    },
  },
  leftBox: {},
  rightBox: {
    height: '33.5vw',
    overflow: 'hidden',
    marginLeft: '20px',
    '@media only screen and (max-width: 768px)': {
      display: 'flex',
      height: '30vh',
      marginLeft: '0px',
    },
  },
  slideBox: {
    marginTop: '-168px',
    '@media only screen and (max-width: 768px)': {
      marginTop: '0px',
    },
  },
  textBox: {
    width: '80%',
    marginBottom: '60px',
    marginTop: '106px',
    '@media only screen and (max-width:768px)': {
      marginTop: '32px',
      marginBottom: '32px',
    },
  },
  Text1: {
    height: '29px',
    fontFamily: 'Pretendard',
    fontSize: '24px',
    lineHeight: 1.25,
    letterSpacing: '-0.24px',
    textAlign: 'left',
    color: '#191919',
    '@media only screen and (max-width:768px)': {
      fontSize: '16px',
    },
  },

  mainImageBox: {},
  moveBox: {
    '@media only screen and (max-width: 768px)': {
      display: 'flex',
      overflow: 'scroll',
    },
  },
  btnBox: {
    width: '15vw',
    display: 'flex',
    justifyContent: 'center',
    paddingLeft: '20px',
    margin: '58px 0',
    '@media only screen and (max-width: 768px)': {
      margin: '0',
    },
  },
  btn: {
    '@media only screen and (max-width: 768px)': {
      display: 'none',
    },
  },

  slideImage: {
    width: '15vw',
    marginBottom: '20px',
    '@media only screen and (max-width: 768px)': {
      marginRight: '24px',
      width: '29vw',
    },
  },
  mapBox: {
    display: 'flex',
    alignItems: 'center',
    '@media only screen and (max-width: 768px)': {
      height: '32vw',
      minHeight: '120px',
      maxHeight: '224px',
    },
  },
  titleName2: {
    marginLeft: '24px',
    fontSize: '20px',
    fontFamily: 'Pretendard',
    lineHeight: 1.25,
    letterSpacing: '-0.24px',
    textAlign: 'left',
    color: '#191919',
    '@media only screen and (max-width: 768px)': {
      display: 'none',
    },
  },
});

const bannerData = {
  imgSrc: '/images/image/message title@2x.png',
  imgSrcM: '/images/image/messagem title@2x.png',
  title: 'BoB Center Introduce',
  text1: 'Depolis Knowledge Industry Center',
  text2: '(10-minute walk from Gasan Digital Complex Station Exit 6)',
};

export default function CenterPage() {
  const classes = useStyles();
  const [leftImage, setLeftImage] = useState('');
  const [margin, setMargin] = useState(0);
  const ChangeLeftImage = (data) => {
    setLeftImage(data);
  };

  const upBtn = () => {
    if (margin < 0) {
      setMargin(margin + 20);
    }
  };
  const downBtn = () => {
    if (-60 < margin) {
      setMargin(margin - 20);
    }
  };

  useEffect(() => {
    document.querySelector('#moveBox').style.marginTop = `${margin}vw`;
    document.querySelector('#moveBox').style.transition = `all 0.3s`;
  }, [margin]);

  return (
    <Box className={classes.root}>
      <Banner bannerData={bannerData} />
      <Box className={classes.textBox}>
        <Typography className={classes.Text1}>26th and 27th floors</Typography>
        <Typography className={classes.Text1}>Total 1,146 floors space</Typography>
      </Box>

      <Box className={classes.mainBox}>
        <Box className={classes.leftBox}>
          <ImageBox data={leftImage} />
        </Box>
        <Box className={classes.slideBox}>
          <Box className={classes.btnBox}>
            <Button className={classes.btn} onClick={upBtn}>
              <KeyboardArrowUpIcon color='disabled' sx={{ fontSize: 40 }} />
            </Button>
          </Box>
          <Box className={classes.rightBox}>
            <Box id='moveBox' className={classes.moveBox}>
              {imageItems.map((data, i) => {
                return (
                  <Box className={classes.mapBox} key={i}>
                    <img className={classes.slideImage} src={data.ImageSrc} alt={`Center Introduce ${i}`} onClick={ChangeLeftImage.bind(this, data)} />
                    <Typography className={classes.titleName2}>{data.ImageName}</Typography>
                  </Box>
                );
              })}
            </Box>
          </Box>
          <Box className={classes.btnBox}>
            <Button className={classes.btn} onClick={downBtn}>
              <KeyboardArrowDownIcon color='disabled' sx={{ fontSize: 40 }} />
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
